// eslint-disable-next-line jira/restricted/react-component-props
import type { ComponentProps } from 'react';
import flow from 'lodash/flow';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import StatelessButton from './view.tsx';

export default flow(withFireUiAnalytics({ onClick: 'createBoard' }), injectIntl)(StatelessButton);

export type Props = Flow.Diff<
	JSX.LibraryManagedAttributes<typeof StatelessButton, ComponentProps<typeof StatelessButton>>,
	{
		intl: IntlShape;
	}
>;
